// externalData.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_EXTERNAL_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * ExternalData.
 * @module reducer/externalData */
const externalData = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_EXTERNAL_DATA:
      return _MERGE_EXTERNAL_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge external data
 * @kind reducer/actionType
 * @name MERGE_EXTERNAL_DATA
 * @param {object} payload - payload
 * @return {Immutable.Map} New state
 */
const _MERGE_EXTERNAL_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.mergeDeepIn(selectPath, data);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default externalData;
